import AccordionDetails from '@mui/material/AccordionDetails';
import { PropsWithChildren, ReactNode, useState } from 'react';
import { StyledCollapseFilter, StyledContainer, StyledFilterCountWrapper, StyledTitleContainer } from './styles.ts';
import Typography from '@mui/material/Typography';
import { useAppSelector } from '../../hooks/reduxHooks';
import { useDispatch } from 'react-redux';
import { setPriceRangeAction } from '../../store/Product/action';
import openArrowIcon from '../../icons/openArrowIcon.svg';
import crossIcon from '../../icons/crossIcon.svg';
import Image from 'next/image';
import { RobotoFont } from '../../styles/fonts';

interface ICollapseFilter {
  filterName: string;
  columnName?: string;
  openIcon?: ReactNode;
  closeIcon?: ReactNode;
  opened?: boolean;
  borderBottom?: boolean;
  className?: string;
  filterCount?: number;
  openedFilter?: any;
  handleAccordionChange?: (panel: string) => void;
  resetParticularFilter?: (columnName: string) => void;
  forPrice?: boolean;
  forProduct?: boolean;
  mobile?: boolean;
}

const CollapseFilter = ({
  filterName,
  children,
  opened = false,
  openIcon = <Image src={openArrowIcon} alt='Open arrow icon' />,
  closeIcon = <Image src={openArrowIcon} alt='Close arrow icon' />,
  borderBottom,
  className,
  filterCount,
  columnName,
  openedFilter,
  handleAccordionChange,
  resetParticularFilter,
  forPrice,
  forProduct,
  mobile,
}: PropsWithChildren<ICollapseFilter>) => {
  const [open, setOpen] = useState<boolean>(opened ?? true);

  const handleOpenCollapse = () => {
    setOpen((prev) => !prev);
  };

  const expandIcon = open ? closeIcon : openIcon;

  const { priceValues } = useAppSelector((st) => st.products);
  const dispatch = useDispatch();
  function resetFilter(e: any) {
    e.stopPropagation();
    resetParticularFilter && resetParticularFilter(columnName || '');
  }

  return (
    <StyledCollapseFilter className={className} sx={{ display: { md768: mobile ? 'none' : 'block' } }}>
      <StyledContainer
        defaultExpanded={opened}
        expanded={forProduct ? open : openedFilter === `${filterName}`}
        onChange={() => (handleAccordionChange ? handleAccordionChange(`${filterName}`) : null)}
      >
        <StyledTitleContainer
          expandIcon={expandIcon}
          onClick={forProduct ? handleOpenCollapse : () => null}
          aria-controls='panel1a-content'
          style={{ minHeight: '24px', paddingRight: forProduct ? '7px' : '0px' }}
        >
          {forProduct ? (
            <Typography
              variant={'h4'}
              component={'p'}
              sx={{
                fontFamily: `${RobotoFont.style.fontFamily}, sans-serif !important`,
                fontSize: '16px !important',
                lineHeight: '20px !important',
                letterSpacing: '2px !important',
                margin: '16px 0 !important',
                textTransform: 'uppercase',
              }}
            >
              {`${filterName}${filterCount ? `(${filterCount})` : ''}`}
            </Typography>
          ) : (
            <Typography sx={{ margin: 0 }} variant={'h4'} component={'p'}>
              {`${filterName}${filterCount ? `(${filterCount})` : ''}`}
            </Typography>
          )}
          {filterCount ? (
            <StyledFilterCountWrapper>
              <span onClick={(e) => resetFilter(e)}>
                <Image src={crossIcon} alt='Cross icon' />
              </span>
            </StyledFilterCountWrapper>
          ) : null}
          {forPrice && priceValues?.length ? (
            <StyledFilterCountWrapper>
              <span onClick={(e) => dispatch(setPriceRangeAction([]))}>
                <Image src={crossIcon} alt='Cross icon' />
              </span>
            </StyledFilterCountWrapper>
          ) : null}
        </StyledTitleContainer>
        <AccordionDetails>{children}</AccordionDetails>
      </StyledContainer>
    </StyledCollapseFilter>
  );
};

export default CollapseFilter;
